import StickyNotification from "atoms/sticky-notification/sticky-notification";
import React from "react";
import { t } from "utilities/localization-utils";
import TableOfContentMetaData from "organisms/table-of-contents/table-of-content-meta-data";
import useTableOfContents from "utilities/hooks/domain/publications/use-table-of-contents";
import { usePdfPublicationPageState } from "utilities/atoms/pdf-page-atom";
import LegacyPublicationRecord from "models/view-models/legacy-publication-record";
import PdfTableOfContentsEntry from "models/interfaces/pdf-table-of-contents-entry";
import ImagePage from "models/interfaces/image-page";
import PdfNav from "./pdf-table-of-contents";

const BASE_CLASSNAME = "c-publication-page";

interface PdfTableOfContentsWithMetaProps {
    publication?: LegacyPublicationRecord;
    publicationLoaded: boolean;
    pageErrors: string[];
    onBackClick?(): void;
    tableOfContentsEntries: PdfTableOfContentsEntry[];
    pageEntries: ImagePage[];
    code: string;
    edition: string;
    title: string;
    isPublished: boolean;
}

const PdfTableOfContentsWithMeta: React.FC<PdfTableOfContentsWithMetaProps> = (
    props: PdfTableOfContentsWithMetaProps
) => {
    const {
        publication,
        publicationLoaded,
        pageErrors,
        onBackClick,
        tableOfContentsEntries,
        pageEntries,
        code,
        edition,
        title,
        isPublished,
    } = props;

    const { currentPageNumber, setCurrentPageNumber } =
        usePdfPublicationPageState();

    const { handleActiveIdChange, activeId } = useTableOfContents({
        tableOfContentsEntries,
        currentPageNumber,
        pageEntries: pageEntries,
    });

    return (
        <div className={BASE_CLASSNAME}>
            <TableOfContentMetaData
                publication={publication}
                publicationLoaded={publicationLoaded}
                pageErrors={pageErrors}
                onBackClick={onBackClick}
                type="back"
                code={code}
                edition={edition}
                title={title}>
                <PdfNav
                    activeId={activeId}
                    disableExpandOrCollapseAll={true}
                    setActiveId={handleActiveIdChange}
                    setCurrentPageNumber={setCurrentPageNumber}
                    tableOfContentsEntries={tableOfContentsEntries}
                />
            </TableOfContentMetaData>
            {publicationLoaded && !isPublished && (
                <StickyNotification>{t("unpublished")}</StickyNotification>
            )}
        </div>
    );
};

export default PdfTableOfContentsWithMeta;
